import { getActiveLanguage } from "react-localize-redux";

export const selectActiveLanguage = state => getActiveLanguage(state.locale)
export const selectActiveLanguageCode = state => getActiveLanguage(state.locale).code